/**
 * Product card interactions — single delegated handler for all cards site-wide.
 * Handles color swatch image/link swap, active state,
 * and quick-add size buttons that resolve the correct variant
 * based on currently selected color + clicked size.
 */

// ── Helper: get variants JSON from a card ──
function getCardVariants(card) {
  const el = card.querySelector('[data-card-variants]');
  if (!el) return null;
  if (!el._parsed) {
    try {
      el._parsed = JSON.parse(el.textContent);
    } catch {
      el._parsed = [];
    }
  }
  return el._parsed;
}

// ── Helper: get active color on a card ──
function getActiveColor(card) {
  const active = card.querySelector('[data-swatch].is-active');
  return active ? active.dataset.color : null;
}

// ── Color swatches ──
document.addEventListener('click', (e) => {
  const swatch = e.target.closest('[data-product-card] [data-swatch]');
  if (!swatch) return;

  e.preventDefault();
  e.stopPropagation();

  // Skip disabled (out of stock) swatches
  if (swatch.disabled) return;

  const card = swatch.closest('[data-product-card]');
  if (!card) return;

  // Swap primary image (first img inside the card image container)
  const img = card.querySelector('a img');
  if (img && swatch.dataset.imageSrc) {
    img.src = swatch.dataset.imageSrc;
    if (swatch.dataset.imageSrcset) {
      img.srcset = swatch.dataset.imageSrcset;
    }
  }

  // Update all links to point to the correct variant
  if (swatch.dataset.url) {
    card.querySelectorAll('a').forEach((a) => {
      a.href = swatch.dataset.url;
    });
  }

  // Toggle active swatch
  card.querySelectorAll('[data-swatch]').forEach((s) => s.classList.remove('is-active'));
  swatch.classList.add('is-active');
});

// ── Quick-add size buttons ──
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-product-card] [data-size-value]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const card = btn.closest('[data-product-card]');
  if (!card) return;

  const variants = getCardVariants(card);
  if (!variants || variants.length === 0) return;

  const sizeValue = btn.dataset.sizeValue;
  const colorValue = getActiveColor(card);
  const colorIdx = card.dataset.colorIndex != null ? parseInt(card.dataset.colorIndex) : -1;
  const sizeIdx = card.dataset.sizeIndex != null ? parseInt(card.dataset.sizeIndex) : -1;

  // Find variant matching selected color + clicked size
  const variant = variants.find((v) => {
    if (!v.available) return false;
    const sizeMatch = sizeIdx >= 0 ? v.options[sizeIdx] === sizeValue : true;
    const colorMatch = colorIdx >= 0 && colorValue ? v.options[colorIdx] === colorValue : true;
    return sizeMatch && colorMatch;
  });

  if (!variant) return;

  const originalText = btn.textContent;
  btn.textContent = '...';

  // Pre-order products (custom.preorder metafield) carry a hidden line item
  // property so they can be identified in the cart and on the order.
  const payload = { id: variant.id, quantity: 1 };
  if (card.dataset.preorder === 'true') {
    payload.properties = { _preorder: 'true' };
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
    .then((res) => {
      if (!res.ok) throw new Error('Add to cart failed');
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:open'));
    })
    .catch((err) => console.error('Add to cart error:', err))
    .finally(() => {
      btn.textContent = originalText.trim();
    });
});
